import useAxiosCall from './useAxiosCall';
import { useTranslation } from '../Context/TranslationContext';
import { useDomain } from '../Context/DomainContext';
import { decryptData, encryptData } from '../Utilities/CryptoUtility';
const useTranslations = () => {
    const { makeApiCall } = useAxiosCall();
    const { setTranslations, completeTranslationsLoading, clearTranslations } = useTranslation();
    const { domain: contextDomain } = useDomain();

    const handleApiCallSuccess = (data) => {
        let decryptedData = decryptData(data.data);
        setTranslations(decryptedData.translations);
    };

    const handleApiCallError = (errorMessage) => {
        console.error('Error fetching translations:', errorMessage);
        completeTranslationsLoading();
    };

    const fetchTranslations = async (domainOverride) => {
        try {
            const domain = domainOverride != null ? String(domainOverride) : contextDomain;
            if (!domain) {
                console.warn('fetchTranslations: domain not available, skipping');
                clearTranslations();
                return;
            }
            const requestData = {
                data: encryptData(JSON.stringify(
                    {
                        domain
                    }
                ))
            };

            await makeApiCall({
                requestData,
                url: 'getTranslations',
                requestType: 'POST',
                onSuccess: handleApiCallSuccess,
                onError: handleApiCallError,
            });

        } catch (error) {
            console.error('Error fetching translations:', error);
            completeTranslationsLoading();
        }
    };

    return { fetchTranslations };
};

export default useTranslations;
